import Text from 'components/Text/Text';
import React from 'react';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import style from './NoFiltersChangePosition.module.scss';

interface INoFiltersChangePosition {
	isVisible: boolean;
}

const NoFiltersChangePosition: React.FC<INoFiltersChangePosition> = ({ isVisible }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses} data-test="NoFiltersChangePosition">
			<div className={style.iconWrapper}>
				<svg>
					<use xlinkHref={`${breadcrumbs}#specifyFilter`} />
				</svg>
			</div>
			<Text
				className={style.description}
				translationNameSpace="listing"
				translationKey="specifyFiltersTitle"
				theme="secondary"
				size="xl"
				weight="bold"
			/>
		</div>
	);
};

export default NoFiltersChangePosition;
